module.exports = __webpack_public_path__ + "img/living-payment_title.57adf724.png";